import { createClient, SupabaseClient } from '@supabase/supabase-js'
import { env } from '@/shared/config'

export const CC_AUTH_STORAGE_KEY = 'cc-auth'

let cachedClient: SupabaseClient | null = null

export function makeSupabaseClient(): SupabaseClient {
  if (cachedClient) {
    return cachedClient
  }
  cachedClient = createClient(env.supabaseUrl, env.supabaseAnonKey, {
    auth: {
      persistSession: true,
      storageKey: CC_AUTH_STORAGE_KEY,
      flowType: import.meta.env.DEV ? 'implicit' : 'pkce',
    },
  })
  return cachedClient
}
